var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 18,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 98,
    r: 22,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 68,
    r: 22,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 38,
    r: 22,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 68,
    r: 22,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442,
    cy: 98,
    r: 22,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 84 116 L 172 208 L 256 76 L 340 208 L 428 116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 160 80 L 208 128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 352 80 L 304 128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 70 120 L 84 178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 442 120 L 428 178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 92 194 L 112 318"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 420 194 L 400 318"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 256 188 L 296 232 L 256 276 L 216 232 Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 162,
    y1: 270,
    x2: 172,
    y2: 270
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 270,
    x2: 350,
    y2: 270
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 320,
    width: 336,
    height: 32,
    rx: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 102,
    y1: 352,
    x2: 102,
    y2: 392
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410,
    y1: 352,
    x2: 410,
    y2: 392
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96,
    y1: 392,
    x2: 416,
    y2: 392
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 424,
    width: 352,
    height: 28,
    rx: 12,
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRole);
export default __webpack_public_path__ + "static/media/role.f2d2345a93199aec6bece746a03f70c4.svg";
export { ForwardRef as ReactComponent };